import { Button, Box } from '@mui/material'

const ConfirmationFooter = ({
  onConfirmSlot,
  isBookingLoading,
  bookingFormData,
  selectedDate,
}) => (
  <Box
    sx={{
      padding: '4px 20px 6px',
      display: 'flex',
      flexDirection: 'column',
      gap: '2px',
      position: 'sticky',
      bottom: 0,
      backgroundColor: 'transparent !important',
      background: 'transparent !important',
      zIndex: 10,
      marginTop: 'auto',
      width: '100%',
      flexShrink: 0,
      marginBottom: 0,
    }}
  >
    <Box
      sx={{
        display: 'flex',
        gap: '12px',
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <Button
        variant="contained"
        color="emrPrimary"
        onClick={onConfirmSlot}
        size="large"
        sx={{
          minWidth: '200px',
          padding: '12px 24px',
          fontSize: '15px',
          fontWeight: 600,
          borderRadius: '10px',
          boxShadow: '0 4px 12px rgba(124, 58, 237, 0.4)',
          '&:hover': {
            boxShadow: '0 6px 16px rgba(124, 58, 237, 0.5)',
            transform: 'translateY(-2px)',
          },
          transition: 'all 0.2s ease',
        }}
        disabled={isBookingLoading || !bookingFormData?.fee}
      >
        {isBookingLoading ? 'Booking...' : 'Confirm & Send Payment Link'}
      </Button>
    </Box>

    <Box
      sx={{
        textAlign: 'center',
        fontSize: '10px',
        color: '#6b7280',
        fontStyle: 'italic',
        backgroundColor: 'transparent',
        lineHeight: 1.3,
        padding: '2px 0',
      }}
    >
      ⚠️ Note: A payment link will be sent to the patient for{' '}
      {selectedDate?.format('DD/MM/YYYY')}
    </Box>
  </Box>
)

export default ConfirmationFooter 